module.exports = __webpack_public_path__ + "img/lvdoubaihe.f9f46a4b.jpg";